export default __webpack_public_path__ + "static/product_example-ffac774f22daf3c5a113ed0f2c5f1acd.svg";